import { combineReducers } from "@reduxjs/toolkit";
import holidayList from "./holidayListSlice";

const reducer = combineReducers({
  holidayList,
});

export default reducer;
